import { render, staticRenderFns } from "./PostingCardV2.vue?vue&type=template&id=382168e4"
import script from "./PostingCardV2.vue?vue&type=script&lang=ts"
export * from "./PostingCardV2.vue?vue&type=script&lang=ts"
import style0 from "./PostingCardV2.vue?vue&type=style&index=0&id=382168e4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('382168e4')) {
      api.createRecord('382168e4', component.options)
    } else {
      api.reload('382168e4', component.options)
    }
    module.hot.accept("./PostingCardV2.vue?vue&type=template&id=382168e4", function () {
      api.rerender('382168e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recruitings/PostingCardV2.vue"
export default component.exports